import {matchPath} from 'react-router';
import Paths from '../../../routes/Paths';
import SettingsTabType from '../SettingsTabType';

export function getSettingsTabByPath(path: string): SettingsTabType | null {
  const dict = {
    [Paths.SettingsMenu]: SettingsTabType.MENU,
    [Paths.PersonalInfo]: SettingsTabType.PERSONAL_INFO,
    [Paths.Channels]: SettingsTabType.CHANNELS,
    [Paths.WorkspaceMembers]: SettingsTabType.WORKSPACE_MEMBERS,
    [Paths.Snippets]: SettingsTabType.SNIPPETS,
    [Paths.WorkspaceSettings]: SettingsTabType.WORKSPACE_SETTINGS,
    [Paths.Billing]: SettingsTabType.BILLING,
    [Paths.BillingPayCancel]: SettingsTabType.BILLING,
    [Paths.BillingPaySuccess]: SettingsTabType.BILLING,
    [Paths.BillingTariff]: SettingsTabType.BILLING,
    [Paths.Tags]: SettingsTabType.MESSAGE_TAGS,
  };

  for (const settingPath of Object.keys(dict)) {
    if (matchPath(settingPath, path)) {
      return dict[settingPath];
    }
  }

  return null;
}

export default getSettingsTabByPath;